import {
  wheelOfLifeCategories,
  wheelOfLifeCategoryColors,
} from "../../../assets/data/data";
import { CHART } from "./CustomChart.constants";

export const getLatestWheelData = (userData) =>
  userData?.wheelOfLife?.[0] ?? {};

export const getTotalScore = (latestWheelData) =>
  wheelOfLifeCategories.reduce(
    (sum, category) => sum + (latestWheelData[category.value] || 0),
    0
  );

export const buildChartData = (latestWheelData) => ({
  labels: wheelOfLifeCategories.map((category) => category.label),
  datasets: [
    {
      label: "Wheel of Life",
      data: wheelOfLifeCategories.map(
        (category) => latestWheelData[category.value] || 0
      ),
      backgroundColor: wheelOfLifeCategoryColors,
      borderWidth: 1,
      borderColor: "#fff",
    },
  ],
});

export const buildChartOptions = (theme) => ({
  plugins: {
    legend: { display: false },
    tooltip: { enabled: true },
  },
  scales: {
    r: {
      ticks: { display: false },
      grid: {
        circular: true,
        color: theme.palette.text.primary,
      },
      max: CHART.MAX_SCORE,
    },
  },
  animation: {
    animateRotate: true,
    animateScale: true,
  },
});

/**
 * Chart.js plugin that draws category labels around the polar chart.
 * Uses unique id to avoid conflict with built-in "labels" plugin.
 */
export const wheelOfLifeLabelsPlugin = {
  id: "wheelOfLifeLabels",
  beforeDraw(chart) {
    const { ctx, chartArea } = chart;
    if (!chartArea) return;

    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const meta = chart.getDatasetMeta(0);
    if (!meta?.data?.length) return;

    const radius =
      (chart.scales.r?.maxWidth ?? 0) / 2 * CHART.LABEL_RADIUS_FACTOR;

    chart.data.labels.forEach((label, index) => {
      const segment = meta.data[index];
      if (!segment) return;

      const { startAngle, endAngle } = segment;
      const angle = (startAngle + endAngle) / 2 - Math.PI / 2;
      const x = centerX + Math.cos(angle) * radius;
      const y = centerY + Math.sin(angle) * radius;

      ctx.save();
      ctx.font = CHART.LABEL_FONT;
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(label, x, y);
      ctx.restore();
    });
  },
};
